import { useI18n } from "vue-i18n";
import { computed } from "vue";
import { useStore } from "vuex";
import { randomBoolean } from "@/helpers/random.js";
import anotherPaymentSystemImg from "@/assets/images/another-payment-system.png";
import wfpImg from "@/assets/paymentSystem/wayforpay.png";
import monoImg from "@/assets/paymentSystem/monopay.png";
import paypalImg from "@/assets/paymentSystem/paypal.png";
import stripeImg from "@/assets/paymentSystem/stripe.png";
import visaMasterCard from "@/assets/paymentSystem/img_3.png";
import invoiceImg from "@/assets/paymentSystem/invoice.png";

const UA_CODE = "UA";

export const usePaymentSystems = () => {
    const { t: $t } = useI18n();
    const store = useStore();

    return computed(() => {
        const codeCountry = store.getters["auth/getCodeCountry"];
        const isUaUser = codeCountry === UA_CODE;

        const baseSystems = [
            {
                name: "WayForPay",
                color: "var(--wayforpay-color)",
                img: wfpImg,
                link: "way-for-pay",
                canSubscriptions: true
            },
            {
                name: "PayPal",
                img: paypalImg,
                link: "paypal",
                canSubscriptions: false
            },
            {
                name: "Visa/Masterсard",
                color: "#ffffff",
                img: visaMasterCard,
                link: "stripe",
                canSubscriptions: true
            },
            // {
            //     name: "MonoPay",
            //     color: "var(--monopay-color)",
            //     img: monoImg,
            //     link: "mono-bank",
            //     canSubscriptions: false
            // },
            {
                name: $t("invoice.form.get"),
                img: invoiceImg,
                functionCall: "getInvoice",
                canSubscriptions: true
            },
            {
                name: $t("general.footer.name"),
                img: anotherPaymentSystemImg,
                functionCall: "anotherPay",
                canSubscriptions: false
            }
        ];

        return baseSystems.filter(
            (system) => system.functionCall !== "getInvoice" || isUaUser
        );
    });
};
